"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSettingLabel = exports.getBillingName = exports.CreateBillingCollectionSchema = exports.BillingSelectorSchema = exports.billingSelectorToString = exports.stringToBillingSelector = void 0;
const Joi = __importStar(require("joi"));
const __1 = require("../..");
const BILLING_SELECTOR_SPLIT = ':-:';
const stringToBillingSelector = (billingSelector) => {
    const [billingAppendixId, creditorId, currency, isAdjustment, caseId, billAfter, caseEnded, billingPrevented,] = billingSelector.split(BILLING_SELECTOR_SPLIT);
    return {
        billingAppendixId,
        creditorId,
        currency: currency,
        isAdjustment: JSON.parse(isAdjustment),
        caseId: caseId || undefined,
        billAfter: billAfter || undefined,
        caseEnded: caseEnded == 'true' ? true : caseEnded == 'false' ? false : null,
        billingPrevented: billingPrevented == 'true'
            ? true
            : billingPrevented == 'false'
                ? false
                : null,
    };
};
exports.stringToBillingSelector = stringToBillingSelector;
const billingSelectorToString = (billingSelector) => `${billingSelector.billingAppendixId}${BILLING_SELECTOR_SPLIT}${billingSelector.creditorId}${BILLING_SELECTOR_SPLIT}${billingSelector.currency}${BILLING_SELECTOR_SPLIT}${billingSelector.isAdjustment}${BILLING_SELECTOR_SPLIT}${billingSelector.caseId || ''}${BILLING_SELECTOR_SPLIT}${billingSelector.billAfter || ''}${BILLING_SELECTOR_SPLIT}${billingSelector.caseEnded}${BILLING_SELECTOR_SPLIT}${billingSelector.billingPrevented}`;
exports.billingSelectorToString = billingSelectorToString;
exports.BillingSelectorSchema = Joi.object({
    creditorId: Joi.string().uuid().required(),
    currency: Joi.string()
        .valid(...Object.values(__1.Currency))
        .required(),
    isAdjustment: Joi.boolean().required(),
    billingAppendixId: Joi.string().uuid().required(),
    caseId: Joi.string().uuid().allow(null),
    billAfter: Joi.string().allow(null),
    caseEnded: Joi.boolean().allow(null),
    billingPrevented: Joi.boolean().allow(null),
});
exports.CreateBillingCollectionSchema = Joi.object({
    newBillings: Joi.array().items(exports.BillingSelectorSchema.append({
        billingVoucherIds: Joi.array().items(Joi.string().uuid()),
    })),
});
const getBillingName = (billing) => `${billing.handle} ${billing.id || 'X'}`;
exports.getBillingName = getBillingName;
var AccountSettingLabel;
(function (AccountSettingLabel) {
    AccountSettingLabel["BankOrPSP"] = "BANK_OR_PSP";
    AccountSettingLabel["CreditorReferenceId"] = "CREDITOR_REFERENCE_ID";
})(AccountSettingLabel || (exports.AccountSettingLabel = AccountSettingLabel = {}));
//# sourceMappingURL=index.js.map